<template>
<div :class="{ 'sticky-table': stickyTopSlot }" ref="listRoot">
    <v-data-table
        id="listPage"

        :headers="headers"

        :items="listItems"
        :item-key="itemKey"

        :no-data-text="noDataText"
        :loading-text="loadingText"
        :no-results-text="loadingText"
        :loading="isLoading"
        hide-default-footer

        :page.sync="currentPage"
        :items-per-page="itemsPerPage"
        
        :server-items-length="totalRecords"
        :options.sync="options"
        @update:options="updatePagingSortingOptions"
        
        :show-expand="showExpand"
        :expanded="expandedStoreItems"
    >   
    <!-- TopSlot (Actions, Buttons etc) -->
        <template v-slot:top>
            <div ref="topSlot" class="pb-3" :class="{ 'sticky-top-slot': stickyTopSlot }" style="background-color:var(--v-listPageTopSlot-base);"><slot name="topSlot" :items="listItems.length"></slot></div>
        </template>

    <!-- Checkboxes for select-all and select-single -->
        <template v-slot:[`header.data-table-select`]>
            <v-checkbox
                :alvqa="alvqa + '-list-checkbox-all-select'"
                color="generalCheckbox"
                v-model="isAllSelected"
                @click="selectAll()"
                hide-details
                class="pt-0 mt-0" 
            ></v-checkbox>  
        </template>    

<!-- DOES NOT WORK, JUST TRYING OUT -->
<!-- <template slot="headers" slot-scope="myprops">
    <td v-for="(header, i) in headers" :key="i">
    {{ myprops.item[header.value] }}
    </td>
</template> -->

    <!-- READONLY on list pages by clicking on a row -->
        <template v-slot:expanded-item="{ item }">
            <td 
                v-if="readOnlyGhostTdSpan !== '0'"
                style="background-color: var(--v-expandPanelBackground-base);"
                :colspan="readOnlyGhostTdSpan"></td>            
            <td 
                style="background-color: var(--v-expandPanelBackground-base);"
                :colspan="(headers.length - readOnlyGhostTdSpan)"
            ><slot name="expandSlot" :id="item.id"></slot></td>
        </template>            
         
    <!-- DATA TABLE CONTENT -->
         <template v-slot:item="{ item, isExpanded }">
            <tr 
                @click="expandItemByClick(item)" :key="item.id"
                :style="{ background: checkForFavourites(item) ? 'var(--v-listPageFavouritesBackground-base)' : '' }"
            >
            <!-- Single Checkbox -->
                <td v-if="headers.some(item => item.value === 'data-table-select')">  
                    <v-checkbox
                        color="generalCheckbox"
                        v-model="selected"
                        :value="item.alvId" 
                        :alvqa="alvqa + '-list-row-' + item.alvId + '-checkbox'"
                        hide-details
                        class="pt-0 mt-0"
                        @click.stop="selectSingle(item.alvId)"
                    ></v-checkbox>  
                </td>  

            <!-- Customized tds in List Pages! -->
                <slot name="body" :item="{ item, isExpanded }"></slot>  
                
            <!-- Ghost Column -->
                <td v-if="headers.some(item => item.value === 'ghost')"></td>
            <!-- EDIT Button-->
                <td v-if="headers.some(item => item.value === 'editForm')" class="text-right" @click="trackMixpanel(item, 'Edit')" @click.stop="() => {}">
                    <BaseIcon   
                        :alvqa="alvqa + '-list-row-' + item.alvId + '-icon-edit'"
                        icon="edit" 
                        :tooltipText="editIconTooltipText(item)"   
                        :color='editIconColor(item)'
                        :to="editIconAction(item)" 
                    />
                </td>
            <!-- DOWNLOAD Button -->
                <td v-if="headers.some(item => item.value === 'downloadLink')" class="text-right" @click="trackMixpanel(item, 'Download')">
                        <BaseIcon 
                            v-if="item.path !== null" 
                            @click.stop="downloadFile(item.path)"                           
                            icon="cloud_download"
                            tooltipText="lang_GENERAL_CAPTION_ICON_DOWNLOAD"
                            :alvqa="alvqa + '-list-row-' + item.alvId + '-icon-download'"
                        />
                </td>
            <!-- PROGRESS Bar -->
                <!-- <td v-if="showProgressLine(item)" class="text-right">
                    <v-progress-linear 
                        :alvqa="alvqa + '-list-row-' + item.alvId + '-progress-bar'"
                        :value="getPercentageForProgress(item)" 
                        color="dialogProgressbar"
                    ></v-progress-linear>
                </td> -->
            <!-- Inline Edit Button-->
                <td v-if="headers.some(item => item.value === 'inlineEdit')" class="text-right">
                    <BaseIcon   
                        :alvqa="alvqa + '-list-row-' + item.alvId + '-icon-inline-edit'"
                        icon="edit" 
                        tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                        @click.stop="editInlineFunction(item)"
                    />
                </td>
             </tr>
         </template>
         <template v-slot:no-data>
             <span :alvqa="alvqa + '-list-no-data-text'">{{ noDataText }}</span>
         </template>
    </v-data-table>    

<!-- PAGINATION: fixed to viewport bottom (sticky jumps when it unsticks at list end) -->
    <div
        v-if="pages() > 1"
        class="list-pagination-spacer"
        :style="{ height: paginationBarHeight + 'px' }"
    ></div>
    <div
        v-if="pages() > 1"
        ref="paginationBar"
        class="list-pagination-fixed"
        :style="paginationBarStyle"
    >
        <v-pagination
            total-visible="10"
            v-model="currentPage"
            :length="pages()"
            color="pagination"
            @input="nextPage()"
        ></v-pagination>
    </div>
</div>
</template>

<script>
import VDataTable from 'vuetify/es5/components/VDataTable'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'
import api from '@/api_alv'

export default {
    name: 'BaseDataTableList',
    extends: VDataTable,
    props: {
        // BASE props
        headers: {
            required: true,
            type: Array,
            default: []
        },
        context: { // used to get and set all page specific data.
            required: true,
            type: String,
            default: ''
        },
        skipInitialFetch: {
            type: Boolean,
            default: false
        },
        customNoDataText: {
            type: String,
            default: null
        },
        // LIST props
        itemKey: { // unique "value" of header/column to identify the selected item(s). See e.g. "Works.vue": computed "headers".
            type: String, //  vuetify default: 'id'
        },
        showExpand: {
            type: Boolean,
            default: true
        },
        groupBy: { // only supports a single grouping (see vuetify documentation).
            type: String | Array, // "value" of header/column. See e.g. "Works.vue": computed "headers".
        },
        readOnlyGhostTdSpan: {
            type: String,
            default: "0"
        },
        alvqa: {
            type: String,
            default: ''
        },
        editInlineFunction: Function,
        differentItemsPerPage: {
            default: null,
            type: Number
        },
        hasServerSideSorting: {
            type: Boolean,
            default: false
        },
        stickyTopSlot: {
            type: Boolean,
            default: false
        },
    },
    components: {
        BaseButton,
        BaseIcon
    },
    data() {
        return {
            listLoading: false,
            paginationBarHeight: 48,
            paginationBarStyle: {},
        }
    },
    computed: {
		// Returns all items from the moudular Vuex Store (e.g. works.js).
        listItems() { 
            let items = this.$store.getters['get'+this.context] 
            if(items === undefined) items = []
            return items
        },	

        itemsPerPage() { 
            if(this.differentItemsPerPage !== null) return this.differentItemsPerPage
            else return this.$store.getters.getItemsPerPage 
        },

        // sets informations for the loading bar.
        // listLoading tracks this list's own fetch so a faster sibling fetch resetting the
        // shared global flag can't prematurely surface the "no data" text while we're still loading.
        isLoading() { return this.listLoading || this.$store.getters.getIsLoading },	
        loadingText() { return this.$t('lang_GENERAL_LOADING_DATATABLE')},

		// Returns a text if there is no data from the API Call.      
        noDataText() { 
            if (this.customNoDataText) return this.$t(this.customNoDataText)
            return this.$t(this.$store.getters.getNoDataText) 
        }, 

        listedItems() { return this.$store.getters.getTotalListed },

        totalRecords() { return this.$store.getters.getTotalRecords },
        options: { 
            get() { 
                if (this.hasServerSideSorting)
                    return this.$store.getters['get'+this.context+'ServerSideSortingOptions'] 
                else 
                    return {}
                },
            set(options) { 
                if (this.hasServerSideSorting)
                    this.$store.commit('set'+this.context+'ServerSideSortingOptions', options) 
                }
        },

        currentPage: {
            get() { return this.$store.getters.getCurrentPage },
            set(page) { this.$store.commit('setCurrentPage', page)}
        },

        isAllSelected: {
            get() { return this.$store.getters['getIsAllSelected'+this.context] },
            set(isSelected) { this.$store.commit('setIsAllSelected'+this.context, isSelected) }
        },
        
        // Getter + Setter for the checked items. See modular store (e.g. works.js).
        selected: {
            get() { return this.$store.getters['getSelected'+this.context] },
            set(alvId) { this.$store.commit('setSelected'+this.context, alvId) }
        } ,
        expandedStoreItems: {
            get() { return this.$store.getters['getExpanded'+this.context] },
            set(item) { this.$store.commit('setExpanded'+this.context, item) }
        },
    },
    methods: {
		// Calculates how many pages are available.
		pages() {
            if (this.itemsPerPage == null || this.listItems.length == null) return 0 
            return Math.ceil(this.listedItems / this.itemsPerPage)
        },
        editIconAction(item){
            if (item.editable !== undefined && item.editable !== null) {
                if (!item.editable) return
            }
            return { name: this.context+'Edit', params: { alvId: item.alvId }}
        },
        editIconColor(item){
            if (item.editable !== undefined && item.editable !== null) {
                if (!item.editable) return '#D0D0D0'
            }
            return 'buttonStandard'
        },
                
        editIconTooltipText(item){
            if (item.editable !== undefined && item.editable !== null) {
                if (!item.editable) return "lang_GENERAL_CAPTION_ICON_NOT_EDITABLE"
            }
            return "lang_GENERAL_CAPTION_ICON_EDIT"
        },

        // Expand behaviour when clicking on a row. 
        async expandItemByClick(item) {    
            if(this.showExpand === true) { // Check if expand function is wanted.                
                let closed = false
                for(let i = 0; i < this.expandedStoreItems.length; i++) {
                    if(this.expandedStoreItems[i]["id"] === item.id) { // CLOSE item
                        this.expandedStoreItems.splice(i, 1)
                        closed = true
                    }
                }
                if(!closed) {
                    this.$store.commit('setIsLoading', true)
                    await this.$store.dispatch('fetch' + this.context + 'Details', item.alvId)
                    this.expandedStoreItems = this.$store.getters['get' + this.context + 'Details']
                }
            }  
        },

        // Select all items function
        selectAll() {
            this.selected = []

            if(this.isAllSelected) {
                this.listItems.forEach(item => {
                    this.selected.push(item['alvId'])
                });
            }
        },

        // Select single line function (all select if all single line boxes are selected)
        selectSingle() {
            if(this.selected.length === this.listItems.length) this.isAllSelected = true
            else this.isAllSelected = false
        },
        // Dispatches this list's fetch while keeping listLoading true for its whole duration,
        // so the loading indicator stays reliable regardless of other concurrent fetches.
        async fetchList() {
            this.listLoading = true
            try {
                await this.$store.dispatch('fetch' + this.context)
            } finally {
                this.listLoading = false
                if (this._scrollToTopAfterFetch) {
                    this._scrollToTopAfterFetch = false
                    this.$nextTick(() => window.scrollTo({ top: 0 }))
                }
            }
        },
        async nextPage() {
            // Server-side lists already fetch via @update:options when page changes
            // (v-pagination v-model -> :page.sync -> options). Fetching here too = duplicate call.
            // Scroll after fetch: goTo('#listPage') does nothing when already inside the tall table.
            this._scrollToTopAfterFetch = true
            if (!this.hasServerSideSorting) {
                await this.fetchList()
            }
        },
        // showProgressLine(item) {  
        //     if(this.$store.getters['getIs' + this.context + 'Running']) { 
        //         let progressLine = this.$store.getters['getRunning' + this.context + 'PercentValues'].find(element => element.alvId === item.alvId) !== undefined

        //         if(progressLine) return true
        //         else return false
        //     } else return false            
        // }, 
        // getPercentageForProgress(item) {
        //     let element = this.$store.getters['getRunning' + this.context + 'PercentValues'].find(element => element.alvId === item.alvId)
        //     return element.percent
        // },
        checkForFavourites(item) {
            if(item.hasOwnProperty('favourites')) {
                return item.favourites === 'yes' ? true : false
            } else return false
        },
        downloadFile(path) {
            api.getFileFromALV(path)
        },
        updatePagingSortingOptions() {
            if (!this.hasServerSideSorting) return
            // Vuetify 2 often emits update:options twice on mount; only fetch when
            // paging/sort actually change (or after brief settle so duplicate emits collapse).
            clearTimeout(this._optionsFetchTimer)
            this._optionsFetchTimer = setTimeout(() => {
                const opts = this.options || {}
                const sortSig = JSON.stringify({ sortBy: opts.sortBy, sortDesc: opts.sortDesc })
                const prev = this._lastOptionsSnapshot
                // Sort click resets Vuetify page to 1; keep prior page (fetch uses getCurrentPage).
                let page = this.currentPage
                if (
                    prev &&
                    sortSig !== prev.sortSig &&
                    page === 1 &&
                    prev.page > 1
                ) {
                    page = prev.page
                    this.$store.commit('setCurrentPage', page)
                    if (opts.page !== undefined) {
                        this.options = { ...opts, page }
                    }
                }
                const key = JSON.stringify({
                    page,
                    itemsPerPage: opts.itemsPerPage,
                    sortBy: opts.sortBy,
                    sortDesc: opts.sortDesc,
                })
                if (key === this._lastOptionsFetchKey) return
                this._lastOptionsFetchKey = key
                this._lastOptionsSnapshot = { page, sortSig }
                this.fetchList()
            }, 50)
        },
        trackMixpanel(item, event) {
            if (item != undefined) {
                mixpanel.track(event , {
                    'entityIds': item.alvId,
                    'routePath': this.$route.path,
                    'userId': this.$store.getters.getUser.id,
                })
            }
        },
        // Publishes the exact vertical distance between the action row and the column-header row
        // so the sticky thead stacks flush below the sticky action row (no jump, no overlap).
        // We measure the real gap (thead top minus action-row top) instead of relying on the
        // action row's box height, because padding/margins between the top slot and the table
        // differ per page. Only measured while unscrolled, where both rows sit at their natural
        // positions and the bounding rects reflect true layout.
        updateTopSlotHeight() {
            const el = this.$refs.topSlot
            if (!el) return
            if (Math.abs(window.pageYOffset) > 4) return
            const thead = this.$el.querySelector('.v-data-table__wrapper thead')
            if (!thead) return
            const gap = Math.round(thead.getBoundingClientRect().top - el.getBoundingClientRect().top)
            if (gap > 0) this.$el.style.setProperty('--alv-sticky-topslot-height', gap + 'px')
        },
        // Keep fixed pager aligned to the list column (drawer open/close, resize).
        syncPaginationBar() {
            const root = this.$refs.listRoot
            if (!root || this.pages() <= 1) return
            const rect = root.getBoundingClientRect()
            this.paginationBarStyle = {
                left: Math.round(rect.left) + 'px',
                width: Math.round(rect.width) + 'px',
            }
            this.$nextTick(() => {
                if (this.$refs.paginationBar) {
                    this.paginationBarHeight = this.$refs.paginationBar.offsetHeight
                }
            })
        },
    },
    watch: {
        listedItems() {
            this.$nextTick(this.syncPaginationBar)
        },
    },
    created() {
        if (!this.hasServerSideSorting && !this.skipInitialFetch) this.fetchList() // make api call for items in data table           
    },
    mounted() {
        this.$nextTick(() => {
            this.syncPaginationBar()
            if (typeof ResizeObserver !== 'undefined' && this.$refs.listRoot) {
                this._paginationBarObserver = new ResizeObserver(() => this.syncPaginationBar())
                this._paginationBarObserver.observe(this.$refs.listRoot)
            }
            window.addEventListener('resize', this.syncPaginationBar)
        })
        if (!this.stickyTopSlot) return
        this.$nextTick(this.updateTopSlotHeight)
        if (typeof ResizeObserver !== 'undefined' && this.$refs.topSlot) {
            this._topSlotObserver = new ResizeObserver(() => this.updateTopSlotHeight())
            this._topSlotObserver.observe(this.$refs.topSlot)
        }
    },
    beforeDestroy() {
        if (this._topSlotObserver) this._topSlotObserver.disconnect()
        if (this._paginationBarObserver) this._paginationBarObserver.disconnect()
        window.removeEventListener('resize', this.syncPaginationBar)
        clearTimeout(this._optionsFetchTimer)
    }
}
</script>

<style>
#listPage table {
    background-color: var(--v-listPageDataTableBackground-base);
    min-width: 1000px;  /*to enforce horizontal scrollbar */
    max-width: 100%; 
    table-layout: fixed; 
}

.list-pagination-fixed {
    position: fixed;
    bottom: 0;
    z-index: 4;
    background-color: var(--v-listPageTopSlot-base);
    padding: 8px 0;
    box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.08);
}

/* .v-data-table tbody tr.v-data-table__expanded__content {
    background-color: var(--v-expandPanelBackground-base) !important;
} */

/* ===== Sticky list layout (opt-in via stickyTopSlot) ===== */

/* Pins the action row directly below the sticky filters (app-bar height + measured filter height) */
.sticky-table .sticky-top-slot {
    position: sticky;
    top: calc(var(--alv-appbar-height, 128px) + var(--alv-sticky-header-height, 0px));
    z-index: 3;
}

/* The wrapper is a scroll container (overflow-x:auto) which blocks window-based sticky.
   Making it visible lets the column-header row stick against the page scroll.
   Direct-child chain so nested tables (e.g. the expanded read-only view) keep their own overflow. */
.sticky-table > .v-data-table > .v-data-table__wrapper {
    overflow: visible;
}

/* Pins the column-header row (incl. master checkbox) directly below the sticky action row.
   Solid background so scrolling body rows never show through.
   Direct-child chain so ONLY the outer works table sticks; the inner table of the expanded
   read-only view must not become sticky, otherwise it slides over the outer column headers. */
.sticky-table > .v-data-table > .v-data-table__wrapper > table > thead th {
    position: sticky !important;
    top: calc(var(--alv-appbar-height, 128px) + var(--alv-sticky-header-height, 0px) + var(--alv-sticky-topslot-height, 0px));
    z-index: 2;
    background-color: var(--v-listPageDataTableBackground-base);
}

/* The loading bar lives in a separate injected progress thead; keep it out of the sticky
   styling so the (absolutely positioned) v-progress-linear stays visible instead of being
   pinned and painted over by the solid header background. */
.sticky-table .v-data-table__progress th {
    position: static !important;
    top: auto !important;
    z-index: auto !important;
    background-color: transparent !important;
}
</style>